"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.ItemSortBy = void 0;
const validation_1 = require("../validation");
const chain_id_1 = require("./chain-id");
const network_1 = require("./network");
const nft_1 = require("./nft");
const nft_category_1 = require("./nft-category");
var ItemSortBy;
(function (ItemSortBy) {
    ItemSortBy["NAME"] = "name";
    ItemSortBy["NEWEST"] = "newest";
    ItemSortBy["RECENTLY_REVIEWED"] = "recently_reviewed";
    ItemSortBy["RECENTLY_SOLD"] = "recently_sold";
    ItemSortBy["RECENTLY_LISTED"] = "recently_listed";
    ItemSortBy["CHEAPEST"] = "cheapest";
})(ItemSortBy = exports.ItemSortBy || (exports.ItemSortBy = {}));
var Item;
(function (Item) {
    Item.schema = {
        type: 'object',
        properties: {
            id: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            thumbnail: {
                type: 'string'
            },
            url: {
                type: 'string'
            },
            category: nft_category_1.NFTCategory.schema,
            contractAddress: {
                type: 'string'
            },
            itemId: {
                type: 'string'
            },
            rarity: {
                type: 'string'
            },
            price: {
                type: 'string'
            },
            available: {
                type: 'integer'
            },
            isOnSale: {
                type: 'boolean'
            },
            creator: {
                type: 'string'
            },
            beneficiary: {
                type: 'string',
                nullable: true
            },
            tradeId: {
                type: 'string',
                nullable: true
            },
            data: nft_1.NFT.schema.properties.data,
            network: network_1.Network.schema,
            chainId: chain_id_1.ChainId.schema,
            urn: {
                type: 'string'
            },
            createdAt: {
                type: 'integer'
            },
            updatedAt: {
                type: 'integer'
            },
            reviewedAt: {
                type: 'integer'
            },
            soldAt: {
                type: 'integer'
            },
            firstListedAt: {
                type: 'integer',
                nullable: true
            },
            picks: {
                type: 'object',
                properties: {
                    pickedByUser: {
                        type: 'boolean',
                        nullable: true
                    },
                    count: {
                        type: 'integer'
                    }
                },
                required: ['count'],
                nullable: true
            },
            minPrice: {
                type: 'string',
                nullable: true
            },
            utility: {
                type: 'string',
                nullable: true
            },
            minListingPrice: {
                type: 'string',
                nullable: true
            },
            maxListingPrice: {
                type: 'string',
                nullable: true
            },
            listings: {
                type: 'integer',
                nullable: true
            },
            owners: {
                type: 'integer',
                nullable: true
            },
            tradeExpiresAt: {
                type: 'integer',
                nullable: true
            }
        },
        required: [
            'id',
            'name',
            'thumbnail',
            'url',
            'category',
            'contractAddress',
            'itemId',
            'rarity',
            'price',
            'available',
            'isOnSale',
            'creator',
            'data',
            'network',
            'chainId',
            'createdAt',
            'updatedAt',
            'soldAt'
        ]
    };
    Item.validate = (0, validation_1.generateLazyValidator)(Item.schema);
})(Item = exports.Item || (exports.Item = {}));
//# sourceMappingURL=item.js.map